export class FlowNode {
  hotelId: string
  rootId: string
  id: string
  name: string
  description: string
  nodeType: string
  functionIds: string[]
  childNodes: string[]
  options: boolean[]
  index?: number
  left?: number
  right?: number
  //Frontend lvl system
  nodeLevel: number | null
  position?: string | null
}

/** FlowNode without the frontend-only layout fields, as the backend expects it */
export type FlowNodeRequest = Pick<FlowNode, "hotelId" | "rootId" | "id" | "name" | "description" | "nodeType" | "functionIds" | "childNodes" | "options">

export function toFlowNodeRequest(node: FlowNode): FlowNodeRequest {
  return {
    hotelId: node.hotelId,
    rootId: node.rootId,
    id: node.id,
    name: node.name,
    description: node.description,
    nodeType: node.nodeType,
    functionIds: node.functionIds,
    childNodes: node.childNodes,
    options: node.options,
  }
}

export class ParentNode {
  hotelId: string
  rootId: string
  draftId: string
  eventName?: string
  name: string
  description: string
  lastEdited?: Date
  created?: Date
  status: string
  objective: string
  createdBy: string
  cronSchedule?: CronSchedule
  startTime?: string
  endTime?: string
  archivedSince?: Date
  lastEditedBy?: string
  nodeType: string
  unPublishedChanges?: boolean
  activeEditing?: string
}

export class ActiveNode {
  hotelId: string
  rootId: string
  draftId: string
  eventName?: string
  name: string
  description: string
  lastEdited: Date
  created: Date
  status: string
  objective: string
  createdBy: string
  cronSchedule?: CronSchedule
  startTime: string
  endTime: string
  lastEditedBy?: string
  unPublishedChanges?: boolean
  activeEditing?: string
}

export class ArchivedNode {
  hotelId: string
  rootId: string
  draftId: string
  eventName: string
  name: string
  description: string
  archivedSince?: Date
  lastEdited?: Date
  created?: Date
  status: string
  objective: string
  createdBy: string
  cronSchedule?: CronSchedule
  startTime?: string
  endTime?: string
  lastEditedBy?: string
  unPublishedChanges?: boolean
  activeEditing?: string
}

export class CronSchedule {
  second: string
  minute: string
  hour: string
  dayOfMonth: string
  month: string
  dayOfWeek: string
  year: string
}

export class NodeInfo {
  nodeType: string
  displayName: string
  description: string
  isStartNode: boolean
  parameters: []
  children: []
  options: []
}
